export default function Footer() {
  return (
    <footer className="w-full py-4 text-center">
      <p className="text-base font-medium" style={{ color: '#B3A369' }}>
        Riyadh. Kingdom of Saudi Arabia.
      </p>
    </footer>
  );
}
